export const stringComparator = (valueA: string, valueB: string) => {
  if (valueA?.toLowerCase() === valueB?.toLowerCase()) {
    return 0
  }
  return (valueA?.toLowerCase() > valueB?.toLowerCase()) ? 1 : -1
}
